import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { AlertContext, BackdropContext } from "../../../contexts";
import { multiFileUpload, assestType } from "../../../utils/common";
import { AlertProps, allowed_file_size } from "../../../utils";
import { useStyles } from "../style";
import { ImageUpload } from "../../../assets/imageupload";
import { ImageCard } from "../../../components";
import { formatSizeUnits } from "../common";
import { withTranslation } from "react-i18next";

const SingleImgUpload = (props) => {

  const { t = () => false } = props

  const alert = React.useContext(AlertContext);
  const backdrop = React.useContext(BackdropContext);
  // const types = ["image/pdf"];

  const checkPdf = (data) => {
    let isvalid = true
    for (let i = 0; i < data.length; i++) {
      if (data[i].type === "application/pdf") {
        isvalid = true
      } else {
        isvalid = false
      }
    }
    return isvalid
  }

  const updateState = async (data) => {
    if (checkPdf(data)) {
      backdrop.setBackDrop({
        ...backdrop,
        open: true,
        message: t("...Uploading"),
      });
      try {
        let propsData = {
          companyId: props?.companyId,
          type: assestType?.General_Images,
        };
        const uploaded_files = await multiFileUpload(data, propsData, alert, allowed_file_size);
        let files = []
        if (uploaded_files?.length > 0) {
          files = uploaded_files?.map((file, index) => {
            return {
              url: file?.url,
              name: data[index]?.name,
              size: formatSizeUnits(data[index]?.size ?? 0),
            }
          })
        }
        if (
          Array?.isArray(props?.selectedImageURL)
          // images?.url[".type"] === ".pdf"
        ) {
          files?.length > 0 && props?.handleChange([...props?.selectedImageURL, ...files]);
        } else {
          alert.setSnack({
            ...alert,
            open: true,
            severity: AlertProps.severity.error,
            msg: t("Pdf Only Allowed"),
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.center,
          });
        }
        backdrop.setBackDrop({
          ...backdrop,
          open: false,
          message: "",
        });
      } catch (err) {
        backdrop.setBackDrop({
          ...backdrop,
          open: false,
          message: "",
        });
        alert.setSnack({
          ...alert,
          open: true,
          severity: AlertProps.severity.error,
          msg: t("Some Thing Went Wrong!"),
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.center,
        });
      }
    } else {
      alert.setSnack({
        ...alert,
        open: true,
        severity: AlertProps.severity.error,
        msg: t("Please Upload PDF Only"),
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.center,
      });
    }
  };

  const deleteImg = (e, index) => {
    const result = props?.selectedImageURL?.filter((x, i) => i !== index);
    props?.handleChange(result);
  };
  const classes = useStyles();
  return (
    <div>
      <Grid container spacing={2}>
        <Grid
          item
          xs={props?.size?.xs ?? 1.8}
          sm={props?.size?.sm ?? 3}
          md={props?.size?.md ?? 3}
          lg={props?.size?.lg ?? 3}
        // xl={props?.size?.xlg ?? 2}
        >
          <label className="btn label">
            <div className={classes.fileroot}>
              <input
                accept=".pdf"
                type="file"
                name="myImage"
                style={{ display: "none" }}
                onChange={(e) => {
                  updateState(e.target.files);
                }}
                multiple
              />
              <center>
                <ImageUpload t={t} />
                <Typography className={classes.uploadTittle}>
                  {t("Upload Attachments here")}
                </Typography>
              </center>
            </div>
          </label>
        </Grid>
        <Grid item xs={props?.size1?.xs ?? 10.2} style={{ display: "flex" }}>
          {props?.selectedImageURL?.map((val, index) => {
            return (
              <>
                <Box className={classes.imgContainer}>
                  <ImageCard
                    image={val?.url ?? ""}
                    onClick={() => deleteImg(val, index)}
                    imageName={val?.name}
                    storage={val?.size}
                    type="pdf"
                    is_pdf
                  />
                </Box>
              </>
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
};
export default withTranslation("announsment")(SingleImgUpload)
